import styled, { css } from 'styled-components';

export const Container = styled.div`
  height: 377px;

  border-radius: 5px;
  background: #fff;
  border: 2px solid #d9d9d9;
  position: relative;
`;

export const Complement = styled.span`
  font-size: 18px;
  font-weight: 500;
  margin-right: 10px;
  border-radius: 8px;
  padding: 0px 10px;
  background: #f6f6f6;
  display: inline-flex;
  align-items: center;
  margin-top: 4px;
  color: #222;
  border: 1px solid #c6c6c6;

  ${(props) =>
    (props.isVeryLate || props.isLate) &&
    css`
      background: #fff;
    `}
`;

export const AverageTime = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Orders = styled.div`
  height: 300px;

  background: #fff;
  border-radius: 5px;
  overflow-y: auto;
  padding-bottom: 48px;
`;

export const Header = styled.div`
  background: #d9d9d9;
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
`;

export const BuyerInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
  border-bottom: 2px solid #d9d9d9;
`;

export const OrdersInfo = styled.main`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
  border-bottom: 1px solid #d9d9d9;

  ${(props) =>
    props.isLate &&
    css`
      background: #ffd894;
    `}

  ${(props) =>
    props.isVeryLate &&
    css`
      background: #db6e7280;
    `}

    &:last-child {
    ${(props) =>
    props.status !== 'pending' &&
    props.status !== 'doing' &&
    css`
        border-radius: 0 0 8px 8px;
      `}
  }
`;

export const ConfirmButton = styled.button`
  width: 100%;
  height: 48px;
  background: #01afff;
  position: absolute;
  bottom: 0;
  border-radius: 0px 0px 5px 5px;
  border: none;
  color: #fff;
  font-size: 18px;
  font-weight: bold;

  ${(props) =>
    props.status === 'doing' &&
    css`
      background: #0ccab4;
    `}
`;

export const ExpandButton = styled.button`
  width: 100%;
  height: 40px;
  background: #f4f4f4;
  position: absolute;
  bottom: 48px;
  border-radius: 0px 0px 5px 5px;
  border: none;
  color: #3d3d3d;
  font-size: 14px;
  font-weight: bold;
`;

export const ProductName = styled.span`
  font-size: 18px;
  font-weight: bold;

  ${(props) =>
    (props.isVeryLate || props.isLate) &&
    css`
      color: #000;
    `}

  ${(props) =>
    (props.canceled || props.checked) &&
    css`
      text-decoration: line-through;
    `}

    ${(props) =>
    props.canceled &&
    css`
      text-decoration: line-through;
      color: #7a7a7a;
    `}
`;

export const DetailsArea = styled.div`
  width: 100%;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  border: 1px solid var(--Takeat-Colors-Neutrals-Grey-01, #c6c6c6);
  background-color: #fff;
`;

export const DetailsHeader = styled.div`
  width: 100%;
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 12px 12px 0px 0px;
  background: var(--Takeat-Colors-Yellow-Variations-01, #ffebc8);
`;

export const Details = styled.div`
  padding: 8px;
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: 0.15px;
`;

export const OrderCount = styled.div`
  gap: 10px;
  border-radius: 100px;
  padding-top: 2px;
  padding-right: 8px;
  padding-bottom: 2px;
  padding-left: 8px;
  background-color: #ff7d24;
  color: #110b0b;
  font-size: 11px;
  font-weight: 800;
`;
